'use client';

import type React from 'react';
import ProfileObjectMobileCard from '@/features/ProfileObjectCard/Mobile/ProfileObjectMobileCard';
import ProfileObjectCard from '@/features/ProfileObjectCard/ProfileObjectCard';
import { useUser } from '@/forApp/states/userState/userState';
import type { RealEstateEntityT } from '@/forApp/types/Entity';
import styles from './styles.module.css';

export type CatalogListCommonProps = {
  catalogList: RealEstateEntityT[];
  typeObj: string;
  isMobile?: boolean;
};

const CatalogListProfile: React.FC<CatalogListCommonProps> = ({
  catalogList,
  typeObj,
  isMobile,
}) => {
  const { user } = useUser();

  if (!catalogList || catalogList.length === 0) {
    return (
      <div className={styles.emptyState}>
        <h3>Объекты не найдены</h3>
        <p>
          Попробуйте изменить параметры поиска или посмотрите другие разделы
          каталога.
        </p>
      </div>
    );
  }

  return (
    <div className={styles.itemList}>
      {catalogList.map((item, index) => (
        <>
          {isMobile ? (
            <ProfileObjectMobileCard
              key={item.id || index}
              card={item}
              type="favorite"
              profile={user ? { role: user.role } : undefined}
              typeObj={typeObj}
            />
          ) : (
            <ProfileObjectCard
              key={item.id || index}
              card={item}
              type="favorite"
              profile={user ? { role: user.role } : undefined}
              typeObj={typeObj}
            />
          )}
        </>
      ))}
    </div>
  );
};

export default CatalogListProfile;
